import React from 'react'

import { Button, Input, InputUI, ModalBox } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import * as S from './GenerateCodesModal.styled'
import { FormFields, type FormValues } from './GenerateCodesModal.types'
import { validationSchema } from './consts'

type GenerateCodesModalProps = {
  title: string
  prefixExample?: string
  close: () => void
  onSubmit: (values: FormValues) => void
}

export const GenerateCodesModal = ({
  title,
  prefixExample = 'PROMO',
  onSubmit,
  close,
}: GenerateCodesModalProps) => {
  const formik = useFormik<FormValues>({
    initialValues: {
      quantity: undefined,
      prefix: undefined,
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values)
      close()
    },
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <ModalBox
        title={title}
        buttons={[
          <Button label="Cancel" onClick={close} />,
          <Button
            label="Generate codes"
            type="submit"
            appearance="primary"
            disabled={!formik.isValid || !formik.dirty}
          />,
        ]}
        size="small"
        onClose={close}
      >
        <S.Info>How many codes would you like to generate?</S.Info>
        <S.QuantityContainer>
          <S.InputContainer>
            <Input
              label="Quantity"
              type="number"
              hideSpinner
              displayError={false}
              {...formik.getFieldProps(FormFields.quantity)}
            />
          </S.InputContainer>
          {formik.errors.quantity && <InputUI.Error>{formik.errors.quantity}</InputUI.Error>}
        </S.QuantityContainer>
        <S.Info>
          What name would you like to appear before each code? (e.g. {prefixExample} will create{' '}
          {prefixExample}_SJ2F, etc.)
        </S.Info>
        <S.InputContainer>
          <Input label="Prefix (optional)" {...formik.getFieldProps(FormFields.prefix)} />
        </S.InputContainer>
      </ModalBox>
    </form>
  )
}
